import { NavLink, useNavigate } from 'react-router-dom'

const links = [
  { to: '/admin', label: 'Dashboard', icon: '📊' },
  { to: '/admin/services', label: 'Services', icon: '🎨' },
  { to: '/admin/portfolio', label: 'Portfolio', icon: '🖼️' },
  { to: '/admin/testimonials', label: 'Testimonials', icon: '💬' },
  { to: '/admin/team', label: 'Team', icon: '👥' },
  { to: '/admin/blog', label: 'Blog', icon: '📝' },
  { to: '/admin/stats', label: 'Stats', icon: '📈' },
  { to: '/admin/clients', label: 'Clients', icon: '🏢' },
  { to: '/admin/contact', label: 'Contact', icon: '📞' },
  { to: '/admin/navigation', label: 'Navigation', icon: '🧭' },
  { to: '/admin/messages', label: 'Messages', icon: '✉️' },
]

export default function AdminSidebar() {
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('token')
    navigate('/admin/login')
  }

  return (
    <aside className="w-64 min-h-screen bg-gray-900 border-r border-white/10 flex flex-col">
      <div className="p-5 border-b border-white/10">
        <h1 className="text-lg font-bold text-white">SST CMS</h1>
        <p className="text-xs text-gray-400 mt-1">Admin Panel</p>
      </div>
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === '/admin'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isActive
                  ? 'bg-electric-blue/20 text-electric-blue font-medium'
                  : 'text-gray-400 hover:text-white hover:bg-white/5'
              }`
            }
          >
            <span className="text-lg">{link.icon}</span>
            {link.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-white/10">
        <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-400 hover:text-white mb-3 transition-colors">
          <span>🔗</span> View Site
        </a>
        <button onClick={handleLogout} className="flex items-center gap-2 text-sm text-red-400 hover:text-red-300 transition-colors w-full">
          <span>🚪</span> Logout
        </button>
      </div>
    </aside>
  )
}
